import type { EventsPortalState } from '../types/events-management'

export const eventsQueryKeys = {
  listing: (state: EventsPortalState, contactId?: string, limit?: number) => ['events', 'listing', state, contactId, limit] as const,
  detail: (eventId?: string) => ['events', 'detail', eventId] as const,
  schedule: (eventId?: string, contactId?: string, includeSaved = false) =>
    ['events', 'schedule', eventId, contactId, includeSaved] as const,
  scheduleBySpeaker: (eventId?: string, contactId?: string, speakerId?: string) =>
    ['events', 'scheduleBySpeaker', eventId, contactId, speakerId] as const,
  speakers: (eventId?: string) => ['events', 'speakers', eventId] as const,
  sponsors: (eventId?: string) => ['events', 'sponsors', eventId] as const,
  advertisements: (eventId?: string, placement?: string) => ['events', 'advertisements', eventId, placement] as const,
  attendees: (eventId?: string, page?: number, search?: string) => ['events', 'attendees', eventId, page, search] as const,
  attendee: (eventId?: string, attendeeId?: string) => ['events', 'attendee', eventId, attendeeId] as const,
  myParticipant: (eventId?: string, contactId?: string) => ['events', 'myParticipant', eventId, contactId] as const,
  user: (eventId?: string, id?: string, role?: string) => ['events', 'user', eventId, id, role] as const,
  connectionActions: (eventId?: string, contactId?: string, participantKeys?: readonly string[]) =>
    ['events', 'connectionActions', eventId, contactId, participantKeys] as const,
  connectionStatuses: (contactId?: string, connectionIds?: readonly string[]) =>
    ['events', 'connectionStatuses', contactId, connectionIds] as const,
  exhibitors: (eventId?: string) => ['events', 'exhibitors', eventId] as const,
  exhibitor: (eventId?: string, exhibitorId?: string) => ['events', 'exhibitor', eventId, exhibitorId] as const,
  exhibitorMemberships: (eventId?: string, contactId?: string) => ['events', 'exhibitorMemberships', eventId, contactId] as const,
  leadContacts: (eventId?: string, exhibitorId?: string, search?: string, order?: string, page?: number) =>
    ['events', 'leadContacts', eventId, exhibitorId, search, order, page] as const,
  leadContactsInfinite: (eventId?: string, exhibitorId?: string, search?: string, order?: string) =>
    ['events', 'leadContacts', 'infinite', eventId, exhibitorId, search, order] as const,
} as const
